import React from 'react';

function Skeleton() {
  return (
    <div className="container">
      {[...Array(3)].map((s, i) => (
        <div key={i} className="maim">
          <div className="box">
            <span className="lineone skeleton">&nbsp;</span>
            <span className="linetwo skeleton">&nbsp;</span>
          </div>
          <div className="box">
            <span className="lineone skeleton">&nbsp;</span>
            <span className="linetwo skeleton">&nbsp;</span>
          </div>
          <div className="box">
            <span className="lineone skeleton">&nbsp;</span>
            <span className="linetwo skeleton">&nbsp;</span>
          </div>
          <div className="box">
            <span className="lineone skeleton">&nbsp;</span>
            <span className="linetwo skeleton">&nbsp;</span>
          </div>
          <div className="box">
            <span className="lineone skeleton">&nbsp;</span>
            <span className="linetwo skeleton">&nbsp;</span>
          </div>

          <div className="box">
            <span className="lineone skeleton">&nbsp;</span>
            <span className="linetwo skeleton">&nbsp;</span>
          </div>
          <div className="box">
            <span className="lineone skeleton">&nbsp;</span>
            <span className="linetwo skeleton">&nbsp;</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Skeleton;
